import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, User as UserIcon, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import api, { setToken } from '../lib/api';
import { toast } from 'sonner';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_travel-booking-hub-90/artifacts/txbpb6pw_20260506_060747_0000.png';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { username, password });
      setToken(res.data.token);
      toast.success('Bienvenido');
      navigate('/admin');
    } catch (err) {
      toast.error('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="TTS" className="h-32 w-auto" />
        </Link>
        <div className="glass-card rounded-2xl p-8">
          <h1 className="text-2xl font-black text-white text-center mb-2">Panel Admin</h1>
          <p className="text-white/60 text-center text-sm mb-8">TTS - Transporte Turístico Santos</p>
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <Label className="text-white/80 mb-2 block">Usuario</Label>
              <div className="relative">
                <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
                <Input value={username} onChange={(e) => setUsername(e.target.value)} required className="bg-black/40 border-white/10 text-white h-11 pl-10" placeholder="admin" />
              </div>
            </div>
            <div>
              <Label className="text-white/80 mb-2 block">Contraseña</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-black/40 border-white/10 text-white h-11 pl-10" placeholder="••••••••" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="btn-orange border-0 w-full h-11 rounded-md font-bold">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Iniciar Sesión'}
            </Button>
          </form>
        </div>
        <p className="text-center text-white/40 text-xs mt-6">Credenciales por defecto: admin / tts2025</p>
      </div>
    </div>
  );
};

export default AdminLogin;
